<template>
  <div class="home">
    <!-- <h2>Home Page</h2> -->
    <!-- 头部和菜单栏 -->
    <indexHeader></indexHeader>
    <!-- 主体内容区 -->
    <navSwiper></navSwiper>
    <!-- 院士风采 -->
    <!-- <newGoodCourse></newGoodCourse> -->
    <!-- 底部 -->
    <foot></foot>
  </div>
</template>

<script>
import indexHeader from "@/components/index/header.vue";
import navSwiper from "@/components/index/navSwiper.vue";
// import newGoodCourse from '@/components/index/newGoodCourse.vue';
import foot from "@/components/foot/foot.vue";

export default {
  metaInfo() {
    return {
      title: "九三学社陕西省委员会", // set a title
      meta: [
        {
          // set meta
          name: "九三学社陕西省委员会",
          content: "九三学社陕西省委员会",
        },
      ],
    };
  },
  components: {
    indexHeader,
    navSwiper,
    // newGoodCourse,
    foot,
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 768px) {
  .home {
    // width: 41.5rem;
  }
}
</style>
